import { render, staticRenderFns } from "./ProjectRestrictions.vue?vue&type=template&id=06470f31&scoped=true&"
import script from "./ProjectRestrictions.vue?vue&type=script&lang=js&"
export * from "./ProjectRestrictions.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRestrictions.vue?vue&type=style&index=0&id=06470f31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06470f31",
  null
  
)

export default component.exports